import { createContext, type PropsWithChildren, useContext } from 'react';
import { type SiteConfig } from '@cx-web/api-clients/site-config-api/types';

export const SiteConfigContext = createContext<SiteConfig>(undefined as any as SiteConfig);
SiteConfigContext.displayName = 'SiteConfigContext';

export type SiteConfigProviderProps = {
  siteConfig: SiteConfig;
};

// siteConfig is a static loader value with a stable identity for the lifetime of the
// page, so the context value is passed straight through without memoisation.
export const SiteConfigProvider = ({ children, siteConfig }: PropsWithChildren<SiteConfigProviderProps>) => {
  return <SiteConfigContext.Provider value={siteConfig}>{children}</SiteConfigContext.Provider>;
};

export const useSiteConfig = (): SiteConfig => {
  const context = useContext(SiteConfigContext);
  if (!context) {
    throw new Error('useSiteConfig can only be used inside of SiteConfigProvider');
  }

  return context;
};
